import React from 'react';
import Tooltip from 'rc-tooltip';

import styles from './ideaViewsBreakdownSectionStyles';

import Icon from 'buyside/components/presentation/Icon/icon';
import ErrorMessage from 'buyside/components/presentation/ErrorMessage/errorMessage';
import ViewsChart from 'buyside/components/presentation/Charts/ViewsChart/viewsChart';

import { getViewDataPairs } from 'buyside/util/ideaViewsHelper';
import { chunk } from 'buyside/util/arrayHelper';

class IdeaViewsBreakdownSection extends React.Component {
  constructor() {
    super();
  }

  renderOtherPairs() {
    const { views, attr } = this.props;
    if (!views) return <ErrorMessage>Something Went Wrong. Please refresh the page.</ErrorMessage>;
    const { otherPairs } = getViewDataPairs(views, attr, 4);
    const otherPairsChunked = chunk(otherPairs, 15);

    return (
      <>
        {otherPairsChunked.map((pairChunk, idx) => (
          <div key={idx}>
            {pairChunk.map((pair, idx) => (
              <div key={idx} className={styles.dataRow}>
                {this.pairSummary(pair)}
              </div>
            ))}
          </div>
        ))}
      </>
    );
  }

  pairSummary(pair) {
    const [value, percentNum] = pair;
    const percentStr = percentNum > 1 ? `${Math.round(percentNum)}%` : '<1%';
    if (value === 'Other') {
      return (
        <Tooltip overlay={this.renderOtherPairs()} placement="bottom">
          <span className={styles.otherMouseable}>Other ({percentStr})</span>
        </Tooltip>
      );
    } else {
      return `${value} (${percentStr})`;
    }
  }

  render() {
    const { views, attr, title, icon } = this.props;
    if (!views) return <ErrorMessage>Something Went Wrong. Please refresh the page.</ErrorMessage>;
    const { topPairs } = getViewDataPairs(views, attr, 4);
    return (
      <>
        <h3 className={styles.heading}>
          <Icon type={icon} />
          {title}
        </h3>
        <div className={styles.viewsBreakdownStat}>
          {topPairs.map((pair, idx) => (
            <div key={idx} className={styles.dataRow}>
              <div className={styles.circle} />
              {this.pairSummary(pair)}
            </div>
          ))}
        </div>
        <ViewsChart pairs={topPairs} />
      </>
    );
  }
}

export default IdeaViewsBreakdownSection;
